import { AttachmentInfo, CommunicationDetails, User } from "@maslul/common-services";

export class ApplicantDetails extends User {
    isPackageYours: string | undefined;
    packageOwnerId: string | undefined;
    packageOwnerFirstName: string | undefined;
    packageOwnerLastName: string | undefined;
    packageOwnerCommunicationDetails: CommunicationDetails| undefined;
    powerOfAttorney: AttachmentInfo = new AttachmentInfo();


    constructor(applicantDetails?: ApplicantDetails) {

        super(applicantDetails as User)
        if (applicantDetails) {
            this.isPackageYours = applicantDetails.isPackageYours;
            this.packageOwnerId = applicantDetails.packageOwnerId;
            this.packageOwnerFirstName = applicantDetails.packageOwnerFirstName;
            this.packageOwnerLastName = applicantDetails.packageOwnerLastName;
            this.packageOwnerCommunicationDetails = new CommunicationDetails(applicantDetails.packageOwnerCommunicationDetails);
            this.powerOfAttorney = new AttachmentInfo(applicantDetails.powerOfAttorney);
        }

    }
}
